import * as cn from "classnames";
import * as React from "react";
import { SvgIcon } from "../components/SvgIcon";
import { Search } from "../icons";

interface CommonSearchComponentProps {
    searchValue: string;
    placeholder: string;
    onSubmit: (query: string) => void;
    className?: string;
}

interface CommonSearchComponentState {
    searchValue: string;
}

export class CommonSearchComponent extends React.Component<CommonSearchComponentProps, CommonSearchComponentState> {
    constructor(props: CommonSearchComponentProps) {
        super(props);
        this.state = {
            searchValue: this.props.searchValue
        };
    }

    componentDidUpdate(prevProps: CommonSearchComponentProps) {
        if (prevProps.searchValue !== this.props.searchValue)
            this.setState({ ...this.state, searchValue: this.props.searchValue });
    }

    handleChange = async (e: any) => {
        await this.setState({
            searchValue: e.currentTarget.value
        });

        await this.props.onSubmit(this.state.searchValue);
    };

    handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        this.props.onSubmit(this.state.searchValue);
    };

    render() {
        const { className } = this.props;

        return (
            <form className={cn("dashboard-search", className)} onSubmit={e => this.handleSubmit(e)}>
                <div className="common-search">
                    <input
                        type="text"
                        className="common-search-input"
                        placeholder={this.props.placeholder}
                        value={this.state.searchValue}
                        onChange={e => this.handleChange(e)}
                    />
                    <button type="submit" className="common-search-btn">
                        {<SvgIcon svg={Search} />}
                    </button>
                </div>
            </form>
        );
    }
}
